var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompliancePdfFileExpired = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 49,
  height: 53,
  viewBox: "0 0 49 53",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#twr2viaqra)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.41 1.111h31.238l11.944 12.491v35.04c0 .75-.582 1.358-1.3 1.358H3.41c-.717 0-1.299-.608-1.299-1.358V2.469c0-.75.582-1.358 1.299-1.358z",
  fill: "#F0EFEF"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m35.16 1.647 11.944 12.491H36.459c-.718 0-1.299-.608-1.299-1.358V1.647z",
  fill: "#ABABAB"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.06 17.722H17.12a2.788 2.788 0 0 0-2.788 2.788v13.758a2.788 2.788 0 0 0 2.788 2.788h13.938a2.788 2.788 0 0 0 2.788-2.788V20.51a2.788 2.788 0 0 0-2.788-2.788z",
  fill: "#ABABAB"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.16 28.593c-.314-.27-.628-.606-.987-.964a5.781 5.781 0 0 1-.74-1.055c.426-1.458.628-2.848.18-3.521-.202-.314-.516-.471-.92-.471-.449 0-.785.201-.942.583-.36.807.18 2.288.83 3.499-.18.583-.404 1.211-.673 1.907a17.05 17.05 0 0 1-.516 1.121c-1.84.718-2.961 1.526-3.118 2.288-.067.359.045.673.359.92.18.134.381.224.606.224.09 0 .179-.022.269-.045.852-.224 1.772-1.48 2.445-2.759.403-.157.875-.314 1.39-.448.606-.18 1.144-.314 1.615-.404.875.695 1.615 1.077 2.266 1.077.493.022.852-.158 1.189-.494.493-.493.291-.92.224-1.032-.404-.628-1.637-.762-3.477-.426zm-5.877 3.701a.222.222 0 0 1-.179-.022c-.09-.068-.09-.112-.067-.157.044-.27.56-.763 1.682-1.301-.538.807-1.077 1.39-1.436 1.48zm3.186-8.815c.022-.045.044-.112.224-.112.157 0 .224.067.27.112.201.291.178 1.032-.068 2.019-.381-.853-.583-1.66-.426-2.02zm.628 5.608-.673.201c.067-.157.134-.314.202-.448.157-.426.336-.853.493-1.301.18.247.337.47.494.628.201.224.403.426.605.628-.359.09-.74.18-1.121.292zm4.733.403c-.157.18-.36.247-.606.247-.337 0-.74-.157-1.211-.471 1.3-.18 2.04-.045 1.817.224z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "twr2viaqra",
  x: 0.111,
  y: 0.111,
  width: 48.48,
  height: 52.889,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.300721 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_228_217"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_228_217",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompliancePdfFileExpired);
export default ForwardRef;